import { ReactNode } from 'react'
import { useTheme } from '../hooks/useTheme'

interface ThemeProviderProps {
  children: ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useTheme(state => state.getThemeStyles())
  
  return (
    <div className={`min-h-screen ${theme.colors.background.base} ${theme.colors.text.primary}`}>
      {children}
    </div>
  )
} 